import { render, staticRenderFns } from "./PopupCompany.vue?vue&type=template&id=0f4907bf"
import script from "./PopupCompany.vue?vue&type=script&lang=js"
export * from "./PopupCompany.vue?vue&type=script&lang=js"
import style0 from "./PopupCompany.vue?vue&type=style&index=0&id=0f4907bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports